import { styled } from '@mui/material';
import type {
  ComponentGroupBentoItem,
  Maybe,
} from '@rumblefish/strapi/strapiTypes';

export const StyledBentoGridItemContainer = styled('div')<{
  item: ComponentGroupBentoItem;
  isMobile: boolean;
}>(({ item, isMobile }) => ({
  gridColumnStart: isMobile ? '1' : item.columnStart,
  gridColumnEnd: isMobile ? '1' : item.columnEnd + 1,
  gridRowStart: isMobile ? 'auto' : item.rowStart,
  gridRowEnd: isMobile ? 'auto' : item.rowEnd + 1,
  backgroundColor: item.backgroundColor || 'transparent',
  borderRadius: isMobile ? '0.75rem' : '1.5rem',
  aspectRatio: item.aspectRatio || '1/1',
  overflow: 'hidden',
  alignContent: 'stretch',
  justifyContent: 'stretch',
  width: '100%',
  height: '100%',
}));

export const StyledBentoGrid = styled('div')<{
  columns: number;
  rows: number;
  gap?: Maybe<number>;
  isMobile: boolean;
}>(({ columns, rows, gap, isMobile }) => ({
  display: 'grid',
  gridTemplateColumns: isMobile ? '1fr' : `repeat(${columns}, 1fr)`,
  gridTemplateRows: isMobile ? 'auto' : `repeat(${rows}, auto)`,
  gap: gap ? `${gap}px` : isMobile ? '1rem' : '1.5rem',
}));

export const StyledBentoGridVideo = styled('video')<{
  item: ComponentGroupBentoItem;
}>(({ item }) => ({
  width: '100%',
  height: '100%',
  objectFit: item.objectFit ? item.objectFit : 'cover',
  objectPosition: 'center',
}));

export const StyledBentoGridImage = styled('img')<{
  item: ComponentGroupBentoItem;
}>(({ item }) => ({
  width: '100%',
  height: '100%',
  objectFit: item.objectFit ? item.objectFit : 'contain',
  padding: item.backgroundColor && item.padding ? item.padding : 0,
  objectPosition: 'center',
}));
